/* Service-worker registration + "new version" detection. Only static assets are cached (see public/sw.js). */
const listeners = new Set();
let waitingWorker = null;

export function onSwUpdate(fn) {
  listeners.add(fn);
  if (waitingWorker) fn(waitingWorker);
  return () => listeners.delete(fn);
}

function announce(worker) {
  waitingWorker = worker;
  listeners.forEach((fn) => fn(worker));
}

export function applySwUpdate() {
  if (!waitingWorker) return;
  waitingWorker.postMessage({ type: "SKIP_WAITING" });
}

export function markStandalone() {
  if (isStandalone()) document.documentElement.classList.add("is-standalone");
  window.matchMedia?.("(display-mode: standalone)")?.addEventListener?.("change", (e) => document.documentElement.classList.toggle("is-standalone", e.matches || window.navigator.standalone === true));
}

export function registerServiceWorker() {
  markStandalone();
  if (!("serviceWorker" in navigator)) return;
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") return;
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
      if (reg.waiting && navigator.serviceWorker.controller) announce(reg.waiting);
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) announce(nw);
        });
      });
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    } catch (e) {
      // registration failures must never break the app
    }
  });
}

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;

export const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) || (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
